import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import BannerLanding from '../components/BannerLanding'
import Image from '../components/ImageShift';
//import { Grid, Row, Col } from 'react-flexbox-grid';

//import win from '../assets/images/windows.png';
//import linux from '../assets/images/linux.png';

const pageTitle = "Mon CV en ligne";
//const pageContent = ["Parmis les compétences ci-dessous,", "j'assure installation, configuration et administration","d'équipements et / ou de services"];
const pageContent = ['Page en cours de construction !'];
const Generic = (props) => (
    <div style={props.transition && props.transition.style}>
        <Helmet>
            <title>Web2alpes - {pageTitle}</title>
            <meta name="description" content="Mon parcours professionnel et formation" />
        </Helmet>
        <BannerLanding title={pageTitle} color="style-logo-lg" particles="infra" content={pageContent} />
        <div id="main" className="alt">
            <section className="tiles-full">
                <section id="comptetences">
                    <div className="inner">
                        <div className="spotlights">
                            <div className="text">
                                <header>
                                    <h2><i className="icon alt fa-sitemap"></i> Reseaux</h2>
                                </header>
                                <ul className="snow">
                                    <li>Installation, configuration et administration réseaux niveau 2 et 3 (routeurs, switchs, Wifi de toute marque HP / Cisco / Nortel / Netgear / Dlink / AlliedTelesyn ...),</li>
									<li>Installation, configuration et administration réseaux wifi (hotspot / réseaux d'entreprises...)</li>
                                    <li>Maitrise des protocoles réseaux de base IPv4 & IPv6, Vlan, Spanning tree, Qos , Ha, Ospf, Bgp, Olsr, Vrf</li>
                                    <li>Installation, configuration et administration de services réseaux (Dns, Dhcp, Radius, Remote logging, NTP, Proxy...),</li>
									<li>Interconnexion site à site</li>
                                    <li>Définition architecture LAN / MAN / WLAN,</li>
                                    <li>Mise en œuvre de montées de version des équipements ou services réseaux,</li>
                                    <li>Défintion de configurations types des équipements (switch, routeurs..),</li>
									<li>Définition de procédures d'exploitation pour tous les équipements et services mises en place</li>
                                    <li>Suivi et gestion des performances (seuil d’alerte et optimisation (tuning)…).</li>
                                </ul>
                            </div>
                            <div className="text">
                                <header>
                                    <h2><i className="icon alt fa-shield"></i> Securite</h2>
                                </header>
                                <ul className="snow">
                                    <li>Sécurisation serveurs (Windows / Linux) et postes de travail,</li>
                                    <li>Mise en place de sauvegarde informatique,</li>
                                    <li>Mise en place de liaisons privées virtuelles (VPN IPSec / SSL),</li>
                                    <li>Installation, configuration et administration de Firewall (Iptables, Ebtables, Netasq, Stormshield, Cisco),</li>
                                    <li>Installation, configuration et administration Sytèmes de détection ou de protection IPS, IDS (snort, suricata),</li>
                                    <li>Réalisation d'audits : Détection d'intrusions et de vulnérabilités via des outils adaptés : Metasploit, Ettercap, Openvas et Nessus,</li>
                                    <li>Installation, configuration et administration de systèmes de supervision : Nagios, Centreon, Cacti, Prtg, Eye of network,</li>
                                    <li>Installation, configuration et administration de serveurs WEB : Apache2, Nginx avec WAF (ModSecurity / Naxsi / DenyAll Isuite (ex beeware),</li>
                                    <li>Mise en place de mécanismes de haute disponibilité sytèmes et réseau (cluster base de données, répartition de charge sur le réseau),</li>
                                    <li>Accompagnement dans l'élaboration d'un plan de reprise ou de continuité d'activité (PCA / PRA).</li>
                                </ul>
                            </div>
                        </div>
                        <div className="spotlights">
                            <div className="text">
                                <header>
                                    <h2><i className="icon alt fa-windows"></i> Windows</h2>
                                </header>
                                <ul className="snow">
                                    <li>Installation, configuration et administration Windows Server 2008/2012/2016,</li>
                                    <li>Mise en place d'environnements de sécurité dynamique pour protéger vos données,</li>
                                    <li>Optimisation et surveiller les performances du système,</li>
                                    <li>Supervision adaptée aux services installés (SNMP / WMI).</li>
                                    <li>Mise en place de domaines Active Directory</li>
                                    <li>Gestion des mises à jour dans un environement domaine</li>
                                    <li>Mise en place de stratégies de groupe (GPO)</li>
                                    <li>Deploiement via le réseau d'images poste de travail.</li>
                                </ul>
                            </div>
                            <div className="text">
                                <header>
                                    <h2><i className="icon alt fa-linux"></i> Linux</h2>
                                </header>
                                <ul className="snow">
                                    <li>Installation, configuration et administration de serveurs LINUX ( Debian / Ubuntu / Centos / Redhat),</li>
                                    <li>Deploiement de tous types de services,</li>
                                    <li>Gestion des environnements de développement, de pré-production et de production,</li>
                                    <li>Supervision adaptée aux services installés sur les serveurs (SNMP / Shell / Nagios),</li>
                                    <li>Développement de solutions d'installation et de déploiement de serveurs (Ansible/shell),</li>
                                    <li>Analyse et expertise des problèmes potentiels liés à l'architecture et proposition de solutions adéquates.</li>
                                </ul>
                            </div>
                        </div>
						<div className="spotlights">
                                        <div className="text">
                                                <header>
                                                        <h2><i className="icon alt fa-cloud"></i> Virtualisation</h2>
                                                </header>
                                                <ul className="snow">
                                                        <li>Installation, configuration et administration de fermes VMware, Xen et KVM, </li>
                                                        <li>Optimisation des performances des systèmes d’exploitation (tuning),</li>
                                                </ul>
                                        </div>
                                        <div className="text">
                                                <header>
                                                        <h2><i className="icon alt fa-database"></i> Stockage</h2>
                                                </header>
                                                <ul className="snow">
														<li>Installation, configuration et administration de dispositifs de stockage NAS / SAN,</li>
                                                        <li>Configuration raid spécifique</li>
                                                </ul>
                                        </div>
                    </div>
                    </div>
                    <div className="spotlights">
						<div className="text">
                        	<header>
                            	<h2><i className="icon alt fa-database"></i> Bases de donnees</h2>
                            </header>
                           	<ul className="snow">
                            	<li>Installation, configuration et administration de bases de données relationnelles Sql / Mysql / Mariadb / PostgresSql</li>
                                <li>Installation, configuration et administration de bases de données objet nosql comme Mongodb / Datastax</li>
                                <li>Mise en place de clusters de base de données (Mysql et Mongodb)</li>
                            </ul>
                        </div>
                        <div className="text">
                            <header>
                                <h2><i className="icon alt fa-sitemap"></i> Developpement</h2>
                            </header>
                            <ul className="snow">
                                <li>Scripting : Bash / Shell / Powershell</li>
                                <li>Perl / Python</li>
                                <li>Web : HTML5 / Javascript / NodeJs / AngularJs / ReactJs / PHP</li>
                                <li>Java avancé</li>
                            </ul>
                        </div>
                    </div>
                </section>
				<section>
                    <div className="inner">
                        <header>
                            <h2><i className="icon alt fa-road"></i> Parcours professionnel</h2>
                        </header>
                        <div className="spotlights">
                            <div className="text">
                                <h3>2016-2018 : Ingenieur reseaux et securite</h3>
                                <p>La Metro - Grenoble</p>
                                <h3>2009-2016 : Ingenieur systemes, reseaux et securite</h3>
                                <p>Ville de Grenoble</p>
                            </div> 
                            <div className="text">
                                <h3>2006-2009 : Ingenieur systemes, reseaux</h3>
                                <p>Alternance - Agglomeration de Montbeliard</p>
                                <h3>2004-2006 : Technicien informatique en alternance</h3>
                                <p>Alternance - Agglomeration de Montbeliard</p>
                            </div>  
                        </div>      
                    </div>          
                </section>
                <section>
                    <div className="inner">
                        <header>
                            <h2><i className="icon alt fa-graduation-cap"></i> Formations</h2>
                        </header>
                        <div className="spotlights">
                            <div className="text">
                                <h3>2011 : Mise a niveau Windows 7/2008</h3>
                                <p>IB Formation, Lyon</p>
                                <h3>2006-2009 : CNAM – Ingenieurs 2000</h3>
                                <p>Spécialité informatique et réseaux, Champs-sur-Marne</p>
                            </div>
                            <div className="text">
                                <h3>2004-2006 : DUT Telecom et reseaux</h3>
                                <p>Alternance, IUT Belfort-Montbéliard</p>
                                <h3>2003-2004 : Administrateur systemes et reseaux Windows 2003</h3>
                                <p>Société Expertease, Strasbourg</p>
                            </div>
                        </div>
                    </div>
                </section>
            </section>
        </div>
    </div>
)

export default Generic



// WEBPACK FOOTER //
// ./src/pages/cv.js